// Module
var code = "<div class=\"flex\" ng-style=\"{'justify-content': ($ctrl.alignment === 'left' ? 'flex-start' : ($ctrl.alignment === 'right' ? 'flex-end' : 'center')) }\"> <img ng-src=\"{{$ctrl.image.src}}\" alt=\"{{$ctrl.image.name}}\"/> </div> ";
// Exports
export default code;